import PalliativePerformanceQuestionnaire from 'shared_src/questionnaires/exam/palliative-performance-scale'
import PEQuestionnaire from 'shared_src/questionnaires/exam/physical'
import ExpectationQuestionnaire from 'shared_src/questionnaires/goals-expectations/expectations'
import ResuscitationQuestionnaire from 'shared_src/questionnaires/goals-expectations/resuscitation-choice'
import SupportingDocumentationQuestionnaire from 'shared_src/questionnaires/goals-expectations/supporting-documentation'
import LifeStyleQuestionnaire from 'shared_src/questionnaires/social-history/lifestyle'
import SubstanceQuestionnaire from 'shared_src/questionnaires/social-history/substance-use'
import ROSQuestionnaire from 'shared_src/questionnaires/symptoms/review-of-systems'

export { SubstanceQuestionnaire }
export { ResuscitationQuestionnaire }
export { SupportingDocumentationQuestionnaire }
export { PalliativePerformanceQuestionnaire }
export { ROSQuestionnaire }
export { PEQuestionnaire }
export { LifeStyleQuestionnaire }
export { ExpectationQuestionnaire }

export default {
  SubstanceQuestionnaire,
  ResuscitationQuestionnaire,
  SupportingDocumentationQuestionnaire,
  PalliativePerformanceQuestionnaire,
  ROSQuestionnaire,
  PEQuestionnaire,
  LifeStyleQuestionnaire,
  ExpectationQuestionnaire
}
